import { GameUI } from "game/gameUI/GameUI"
import { translate } from "game/translate"
import { Popups } from "ui/types/popups"
import { GAEvent, GAEventNames } from "game/analytics/events"
import { Store } from "game/store/gameStore"
import './styles.css'

export const NoHintsPopup = () => {
    const handleNewGame = () => {
        dispatchEvent(new CustomEvent('newGame'));
        GameUI.closePopup(Popups.NO_HINTS_POPUP);

        GAEvent(GAEventNames.NO_HINT_NEW_GAME, {
            id: Store.gameId,
            type: Store.getGameTypeText(),
            difficulty: Store.getDifficultyText(),
            trigger: (window as any).noHintPlace,
        });
    };

    const handleRestartGame = () => {
        dispatchEvent(new CustomEvent('restartGame'));
        GameUI.closePopup(Popups.NO_HINTS_POPUP);

        GAEvent(GAEventNames.NO_HINT_RESTART_GAME, {
            id: Store.gameId,
            type: Store.getGameTypeText(),
            difficulty: Store.getDifficultyText(),
            trigger: (window as any).noHintPlace,
        });
    };

    const handleKeepPlaying = () => {
        Store.resumeGame();
        GameUI.closePopup(Popups.NO_HINTS_POPUP);

        GAEvent(GAEventNames.NO_KEEP_PLAY, {
            id: Store.gameId,
            type: Store.getGameTypeText(),
            difficulty: Store.getDifficultyText(),
            trigger: (window as any).noHintPlace,
        });
    };

    return (
        <div id="no-hints" className="no_hints_modal modals_area active" role="tooltip">
            <div className="no_hints_modal_body" data-ouch={translate("ouch")}>
                <img loading="lazy" src="/assets/no_moves/no_hint_card.webp" alt={translate("no_hints_title")} className="hint_cards" />
                <div className="no_hints_title">{translate("no_hints_title")}</div>
                <div className="hints_modal_bottom">
                    <img loading="lazy" src="/assets/no_moves/hint_king.webp" alt={translate("no_hints_title")} className="hint_king" />
                    <img loading="lazy" src="/assets/no_moves/king_mobile.webp" alt={translate("no_hints_title")} className="hint_king_mobile" />
                    <div className="no_hints__buttons_section">
                        <button className="hints__button hints__button_restart" onClick={handleRestartGame}>{translate("tutorial_restart_button")}</button>
                        <button className="hints__button hints__button_new" onClick={handleNewGame}>{translate("new_game")}</button>
                        <button className="hints__button hints__button_keep" onClick={handleKeepPlaying}>{translate("keep_playing")}</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

